
import { Tooltip, } from 'react-tooltip'
const BoxInfo = (
    {
        id,
        title,
        content = "",
        openOnClick = true,
        place,
        styles = {},
        titleStyle = {},
        titleClass = "",
        containerClass = "",
        render
    }
) => {


    return (

        <div className={`${containerClass} flex items-center`} style={styles}   >
            <span style={titleStyle} className={titleClass} >{title}</span>
            <img id={id} src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
            <Tooltip openOnClick={openOnClick} className='z-100' anchorSelect={`#${id}`} content={content} place={place} html={render} />
        </div>
    )

}

export default BoxInfo;